import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Input,
  Menu,
  NumberFormatter,
  rem,
  Select,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import {
  IconCaretDown,
  IconCheck,
  IconEdit,
  IconFileExport,
  IconSearch,
  IconTimeDuration15,
  IconWindow,
} from "@tabler/icons-react";
import dayjs from "dayjs";
import {
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import {
  formatDateNotTimeZone,
  formatDateTransfer,
} from "../../../common/FormatDate/FormatDate";
import { BASE_API_POS } from "../../../config";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import DetailSupplierSlip from "../../Warehouse/SupplierSlipImport/DetailSupplierSlip.tsx";
import { IconFileTypography } from "@tabler/icons-react";

const EditPriceProduct = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  const [globalFilter, setGlobalFilter] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 3, xl: 1.7 };
  const [selectIds, setSelectIds] = useState<string[] | string>([]);

  const formSeachInput = useForm({
    mode: "uncontrolled",
    initialValues: {
      keySearch: "",
      FromDate: "",
      EndDate: "",
      UpdatePriceStatus: "", //trạng thái
      MaNCC: "", // mã nhà cung cấp
    },
  });
  // console.log("rowSelection", rowSelection);
  // console.log("selectIds", selectIds);
  const openModalPaymentBase = async (id: string | string[]) => {
    modals.openConfirmModal({
      title: <Title order={5}>Xác nhận sửa giá</Title>,
      children: (
        <>
          <Flex justify={"end"} gap={20} mt={"sm"}>
            <Button
              color="gray"
              leftSection={<IconWindow size={18} />}
              onClick={() => {
                modals.closeAll();
              }}
            >
              Huỷ
            </Button>
            <Button
              leftSection={<IconCheck size={18} />}
              onClick={() => {
                handleUpdatePrice(id);
                fetchData();
                modals.closeAll();
              }}
            >
              Xác nhận
            </Button>
          </Flex>
        </>
      ),
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
      size: "400px",
      classNames: {
        title: "custom-modal-title",
        body: "custom-modal-body",
      },
    });
  };

  const handleUpdatePrice = async (id: string | string[]) => {
    try {
      // const url = `/api/v1/ImportBill/update-price?PIds=${id}`;
      const response = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/ImportBill/update-price",
        {
          PIds: id,
        }
      );
      if (response?.success) {
        NotificationExtension.Success("Cập nhật giá thành công");
      }
      //  else {
      //   NotificationExtension.Fails(
      //     "Có lỗi xảy ra trong quá trình cập nhật giá. Vui lòng thử lại sau."
      //   );
      // }
    } catch (error) {
      NotificationExtension.Fails(
        "Có lỗi xảy ra trong quá trình cập nhật giá. Vui lòng thử lại sau."
      );
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);

    try {
      let url = `/api/v1/ImportBill/get-list?Loai=${3}&Skip=${
        pagination?.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      if (formSeachInput.getValues().MaNCC) {
        url += `&MaNCC=${formSeachInput.getValues().MaNCC}`;
      }
      if (formSeachInput.getValues().UpdatePriceStatus) {
        url += `&UpdatePriceStatus=${
          formSeachInput.getValues().UpdatePriceStatus
        }`;
      }
      if (formSeachInput.getValues().FromDate) {
        url += `&FromDate=${formatDateNotTimeZone(
          formSeachInput.getValues().FromDate
        )}`;
      }

      if (formSeachInput.getValues().EndDate) {
        url += `&EndDate=${formatDateNotTimeZone(
          formSeachInput.getValues().EndDate
        )}`;
      }
      const response = await repositoryPos.get<MessageResponse<any>>(url);
      if (response && response.success) {
        console.log("response", response);
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
      } else {
        setData([]);
        setRowCount(0);
        setIsLoading(false);
      }
    } catch (error) {
      setData([]);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };
  useEffect(() => {
    const handleCheckView = async () => {};
    handleCheckView();
  }, []);

  const openModal = (id: string) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Chi tiết phiếu nhà cung cấp!</Title>
        </>
      ),
      size: "90%",
      children: <DetailSupplierSlip id={id} />,
      labels: { confirm: "Confirm", cancel: "Cancel" },
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "soCt",
        header: "Số chứng từ",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              style={{ cursor: "pointer" }}
              onDoubleClick={() => openModal(row.original.id)}
              variant="filled"
              radius="xl"
            >
              {renderedCellValue === null
                ? "Không xác định"
                : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
        size: 120,
      },
      {
        accessorKey: "ngayCt",
        header: "Ngày chứng từ",
        Cell: ({ renderedCellValue }: any) => {
          return <>{formatDateTransfer(renderedCellValue)}</>;
        },
      },
      {
        accessorKey: "attribute1",
        header: "Trạng thái",
        Cell: ({ cell }) => {
          const value = cell.getValue<string | null>();
          const isUpdated = value !== null;

          return (
            <Badge
              variant="light"
              bd={`1px solid ${isUpdated ? "green" : "cyan"}`}
              color={isUpdated ? "green" : "cyan"}
            >
              {isUpdated ? "Đã cập nhật" : "Chưa cập nhật"}
            </Badge>
          );
        },
      },
      {
        accessorKey: "maGiaoDichKho",
        header: "Mã phiếu nhập kho",
        Cell: ({ renderedCellValue }: any) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "ngayGiaoDichKho",
        header: "Ngày nhập kho",
        Cell: ({ renderedCellValue }: any) => {
          return <>{formatDateTransfer(renderedCellValue)}</>;
        },
      },

      {
        accessorKey: "plNhapTra",
        header: "Loại phiếu",
        size: 230,
        Cell: ({ row }: { row: { original: { plNhapTra?: number } } }) => {
          const { plNhapTra } = row?.original || {};

          const statusMap: Record<number, { color: string; label: string }> = {
            1: { color: "blue", label: "Nhập hàng nhà cung cấp" },
            3: { color: "violet", label: "Nhập khác" },
          };

          const { color = "gray", label = "Không xác định" } =
            statusMap[plNhapTra!] || {};

          return (
            <Badge variant="light" bd={`1px solid ${color}`} color={color}>
              {label}
            </Badge>
          );
        },
      },
      {
        accessorKey: "maNCC",
        header: "Mã nhà cung cấp",
        Cell: ({ renderedCellValue }: any) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "tenNCC",
        header: "Tên nhà cung cấp",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
        size: 250,
      },
      {
        accessorKey: "ttNhapHang",
        header: "Tình trạng nhập hàng",
        Cell: ({ renderedCellValue }) => {
          const payerType = renderedCellValue;
          let badgeColor;
          let text;

          switch (payerType) {
            case "HOAN_THANH":
              badgeColor = "green";
              text = "Hoàn thành";
              break;
            case "CHUA_NHAP":
              badgeColor = "red";
              text = "Chưa nhập";
              break;
            case "DA_NHAP":
              badgeColor = "blue";
              text = "Đã nhập";
              break;
            case "CHUA_XUAT":
              badgeColor = "gray";
              text = "Chưa xuất";
              break;
            case "DANG_NHAP":
              badgeColor = "orange";
              text = "Đang nhập";
              break;
            default:
              badgeColor = "dark";
              text = "Không xác định";
          }

          return (
            <Badge
              variant="light"
              bd={`1px solid ${badgeColor}`}
              color={badgeColor}
            >
              {text}
            </Badge>
          );
        },
      },
      {
        accessorKey: "maCty",
        header: "Mã chi nhánh",
        size: 150,
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            style={{ cursor: "pointer" }}
            variant="light"
            radius="xl"
            color="violet"
          >
            {renderedCellValue === null ? "Không xác định" : renderedCellValue}
          </Badge>
        ),
      },
      {
        accessorKey: "httt",
        header: "Hình thức thanh toán",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "nguoiGd",
        header: "Người giao dịch",
        Cell: ({ renderedCellValue }) => {
          return <>{renderedCellValue}</>;
        },
      },
      {
        accessorKey: "tTien0",
        header: "Tổng tiền ",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <Text fw={600}>
            <NumberFormatter
              value={(renderedCellValue as string | number) || 0}
              thousandSeparator=","
            />
          </Text>
        ),
      },
      {
        accessorKey: "tTt",
        header: "Tổng thanh toán",
        size: 150,
        Cell: ({ renderedCellValue }) => (
          <Text fw={600}>
            <NumberFormatter
              value={(renderedCellValue as string | number) || 0}
              thousandSeparator=","
            />
          </Text>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        enableSorting: false,
        enableResizing: false,
        size: 100,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Tooltip label="Chỉnh sửa giá">
            <ActionIcon
              variant="light"
              aria-label="Settings"
              color="orange"
              onClick={() => {
                openModalPaymentBase([row.original.id]);
              }}
            >
              <IconEdit size={20} stroke={1.5} />
            </ActionIcon>
          </Tooltip>
        ),
      },
    ],
    []
  );

  const table = useMantineReactTable({
    columns,
    data: data || [],
    enableColumnResizing: true,
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,

    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "STT", "soCt"],
        right: ["tTien0", "tTt", "action"],
      },
      columnVisibility: { id: true },
      density: "xs",
    },
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    mantineTableContainerProps: {
      style: { maxHeight: height - 100, minHeight: height - 100 },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    rowCount,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter,
    onColumnFiltersChange: setColumnFilters,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      sorting,
      rowSelection,
    },
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    fetchData();
  }, [pagination]);

  const formatCurrencyVND = (value: any) => {
    if (value == null) {
      return "";
    }
    // Định dạng số theo chuẩn Việt Nam
    return value.toLocaleString("vi-VN", {
      minimumFractionDigits: 0, // Không hiển thị phần thập phân
      maximumFractionDigits: 0, // Đảm bảo không có chữ số sau dấu phẩy
    });
  };

  const exportDataExcel = async () => {
    let params = new URLSearchParams();

    // // Add the query parameters if they exist
    // const keySearch = formSeachInput.getValues().keySearch;
    // if (keySearch) {
    //   params.append("KeySearch", keySearch);
    // }

    // const FromDate = formSeachInput.getValues().FromDate;
    // if (FromDate) {
    //   params.append("FromDate", FromDate);
    // }

    // const ToDate = formSeachInput.getValues().ToDate;
    // if (ToDate) {
    //   params.append("ToDate", ToDate);
    // }

    const UpdatePriceStatus = formSeachInput.getValues().UpdatePriceStatus;
    if (UpdatePriceStatus) {
      params.append("UpdatePriceStatus", UpdatePriceStatus);
    }
    let url = `?Skip=${pagination?.pageIndex * pagination.pageSize}&Take=${
      pagination.pageSize
    }`;

    if (formSeachInput.getValues().UpdatePriceStatus) {
      url += `&UpdatePriceStatus=${
        formSeachInput.getValues().UpdatePriceStatus
      }`;
    }

    if (formSeachInput.getValues().keySearch) {
      url += `&KeySearch=${formSeachInput.getValues().keySearch}`;
    }
    if (formSeachInput.getValues().FromDate) {
      url += `&FromDate=${formatDateNotTimeZone(
        formSeachInput.getValues().FromDate
      )}`;
    }

    if (formSeachInput.getValues().EndDate) {
      url += `&EndDate=${formatDateNotTimeZone(
        formSeachInput.getValues().EndDate
      )}`;
    }
    const baseUrl = url.toString()
      ? `/api/v1/SaleByCustByOrder/export-excel?${url.toString()}`
      : `/api/v1/SaleByCustByOrder/export-excel`;

    const _url = BASE_API_POS + baseUrl;

    const fullUrl = new URL(_url);
    const token = localStorage.getItem("token");
    fetch(fullUrl.toString(), {
      method: "GET", // Use the appropriate HTTP method
      headers: {
        Authorization: `Bearer ${token?.replace(/"/g, "")}`,
        "Content-Type": "application/vnd.ms-excel",
      },
    })
      .then((response) => {
        if (response.ok) {
          return response.blob(); // Assuming the response is a file or blob
        } else {
          throw new Error("Failed to fetch the resource");
        }
      })

      .then((blob) => {
        // Open the blob in a new tab
        const url = window.URL.createObjectURL(blob);
        let filename = "bao_cao_doanh_so_ban_hang.xlsx"; // Tên mặc định nếu không có header
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      const dataSelected = data.filter((row) =>
        valuesList.includes(row?.id.toString())
      );
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // 190 là chiều cao của phần phân trang
      // headerHeight là chiều cao của phần header
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize); // Update height on window resize

    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
        <Flex justify={"space-between"} align="center" gap="sm">
          <Button
            variant="outline"
            disabled={selectIds.length < 1}
            onClick={() => {
              openModalPaymentBase(selectIds);
            }}
          >
            Chỉnh sửa giá
          </Button>
          <Menu shadow="md" width={200}>
            <Menu.Target>
              <Button
                // size="xs"
                rightSection={
                  <IconCaretDown style={{ width: rem(14), height: rem(14) }} />
                }
              >
                Chức năng
              </Button>
            </Menu.Target>

            <Menu.Dropdown>
              <Menu.Label>Application</Menu.Label>
              <Menu.Item
                leftSection={
                  <IconFileExport style={{ width: rem(14), height: rem(14) }} />
                }
                onClick={() => exportDataExcel()}
              >
                Export Excel
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Flex>
      </Flex>
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          // marginTop: "10px",
        }}
      >
        <Grid style={{ width: "100%" }} mt={10}>
          {/* <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Từ khoá"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("keySearch")}
              {...formSeachInput.getInputProps("keySearch")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                  localStorage.setItem(
                    "allValueKeySearch",
                    JSON.stringify({
                      ...formSeachInput.getValues(),
                      url: String(window.location.pathname),
                    })
                  );
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              // onChange={(date) => {
              //   formSeachInput.setFieldValue(
              //     "FromDate",
              //     formatDateNotTimeZone(date) || ""
              //   );
              // }}
              key={formSeachInput.key("FromDate")}
              {...formSeachInput.getInputProps("FromDate")}
              value={
                formSeachInput.getValues().FromDate
                  ? dayjs(formSeachInput.getValues().FromDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "FromDate",
                  date ? dayjs(date).toISOString() : "" // Nếu xóa thì set ""
                )
              }
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              // maxDate={new Date(formSeachInput.getValues().FromDate)}
              maxDate={
                formSeachInput.getValues().FromDate
                  ? addMonths(new Date(formSeachInput.getValues().FromDate), 1)
                  : undefined
              }
              // onChange={(date) => {
              //   formSeachInput.setFieldValue(
              //     "ToDate",
              //     formatDateNotTimeZone(date) || ""
              //   );
              // }}
              key={formSeachInput.key("ToDate")}
              {...formSeachInput.getInputProps("ToDate")}
              value={
                formSeachInput.getValues().ToDate
                  ? dayjs(formSeachInput.getValues().ToDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "ToDate",
                  date ? dayjs(date).toISOString() : "" // Nếu xóa thì set ""
                )
              }
              clearable
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chi nhánh"
              searchable
              clearable
              data={dataBranchCode}
              leftSection={<IconMapPin size={20} color="#15aabf" />}
              onClick={() => {
                if (dataBranchCode.length === 0) {
                  DataBranchCode();
                }
              }}
              key={formSeachInput.key("BranchCode")}
              {...formSeachInput.getInputProps("BranchCode")}
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Vui lòng chọn bộ phận"
              searchable
              clearable
              leftSection={<IconUsers size={20} color="#15aabf" />}
              data={dataDepartment}
              onClick={() => {
                if (dataDepartment.length === 0) {
                  fetchDataBp();
                }
              }}
              key={formSeachInput.key("DeparmentCode")}
              {...formSeachInput.getInputProps("DeparmentCode")}
            />
          </Grid.Col> */}
          <Grid.Col span={sizeGrid}>
            <Input
              size="sm"
              placeholder="Mã nhà cung cấp"
              type="text"
              leftSection={<IconSearch color="#15aabf" />}
              key={formSeachInput.key("MaNCC")}
              {...formSeachInput.getInputProps("MaNCC")}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Select
              size="sm"
              placeholder="Chọn trạng thái"
              searchable
              clearable
              data={[
                { label: "Đã cập nhật", value: "DA_CAP_NHAT" },
                { label: "Chưa cập nhật", value: "CHUA_CAP_NHAT" },
              ]}
              leftSection={<IconFileTypography color="#15aabf" />}
              key={formSeachInput.key("UpdatePriceStatus")}
              {...formSeachInput.getInputProps("UpdatePriceStatus")}
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày bắt đầu"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              key={formSeachInput.key("FromDate")}
              {...formSeachInput.getInputProps("FromDate")}
              value={
                formSeachInput.getValues().FromDate
                  ? dayjs(formSeachInput.getValues().FromDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "FromDate",
                  date ? dayjs(date).toISOString() : "" // Nếu xóa thì set ""
                )
              }
              clearable
            />
          </Grid.Col>

          <Grid.Col span={sizeGrid}>
            <DatePickerInput
              size="sm"
              placeholder="Chọn ngày kết thúc"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
              key={formSeachInput.key("EndDate")}
              {...formSeachInput.getInputProps("EndDate")}
              value={
                formSeachInput.getValues().EndDate
                  ? dayjs(formSeachInput.getValues().EndDate).toDate()
                  : null // Nếu không có giá trị, đặt null
              }
              onChange={(date) =>
                formSeachInput.setFieldValue(
                  "EndDate",
                  date ? dayjs(date).toISOString() : "" // Nếu xóa thì set ""
                )
              }
              clearable
            />
          </Grid.Col>
          <Grid.Col span={sizeGrid}>
            <Button
              type="submit"
              leftSection={<IconSearch size={20} />}
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>{" "}
          </Grid.Col>
        </Grid>
      </Box>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default EditPriceProduct;
